export const VehicleClassMasterEndpoints = (builder) => ({

    getVehicleClassesForDropdown: builder.query({
        query: () => '/VehicleClass/get-vehicle-classes',
        providesTags: ['VehicleClassMaster'],
    }),

    getVehicleLoadOrDiscounts: builder.query({
        query: (classId) => `/VehicleClass/get-loadings-discounts/${classId}`,
        providesTags: ['VehicleClassMaster'],
    }),

});
